// extracted by mini-css-extract-plugin
export default {"btn":"player_btn__Q623f","btnc":"player_btnc__KVK5D"};